module.exports = __webpack_public_path__ + "img/AR725.4033b234.png";